import React, { useEffect } from "react";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import ScrollToTop from "./components/ScrollToTop";
import Menu from "./components/Menu";
import scrollreveal from "scrollreveal";
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import Home from './screens/Home';

export default function App() {
  useEffect(() => {
    const sr = scrollreveal({
      origin: "top",
      distance: "80px",
      duration: 2000,
      reset: false,
    });
    sr.reveal(
      `
        nav,
        #home,
        #services,
        #portfolio,
        #testimonials,
        #products,
        #newsletter,
        .footer
    `,
      {
        opacity: 0,
        interval: 200,
      }
    );
  }, []);
  return (
    <BrowserRouter>
      <Navbar />
      <ScrollToTop />
      <Routes>
      <Route path="/" element={<Home/>}>
      </Route>
      <Route path="/menu" element={<Menu/>}>
            </Route>
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}
